import { Button, ResetIconButton } from '@library/components/buttons';
import { useCallback, useContext, useState } from 'react';
import ChevronDownIcon from '@library/assets/images/icons/chevron-down-gray-icon.svg';
import { MemberProfileMapContext } from '@bo-hooks/members/useMemberProfileMapContext';
import { PrizepicksDatePicker } from '@library/components/datePicker';
import { cn } from '@library/component-utils/cn';

export const MemberProfileLocationTableFilters = () => {
  const [createdDatePickerOpen, setCreatedDatePickerOpen] = useState(false);

  const {
    createdAtDate,
    entriesChecked,
    onFilterChange,
    onShowMapTable,
    showMapTable
  } = useContext(MemberProfileMapContext);

  const title = `${entriesChecked ? 'Entry' : 'Sign in'} Coordinates`;
  const placeholder = entriesChecked ? 'Created at' : 'Signed in at';

  const handleFilterChange = useCallback(() => {
    onFilterChange(null);
  }, [onFilterChange]);

  return (
    <div className="flex items-center">
      <Button
        className="text-soClean-110 flex flex-1 items-center gap-4 p-4"
        title="ToggleMapTable"
        onClick={onShowMapTable}
      >
        <span>{title}</span>
        <img
          alt="Chevron Down icon"
          className={cn({ '-rotate-90': showMapTable })}
          src={ChevronDownIcon}
        />
      </Button>
      {showMapTable && (
        <div className="mt-3 flex items-center pr-6">
          <div className="w-60 shrink-0">
            <PrizepicksDatePicker
              calendarClassName="!z-[1001]" // overlay z-index for map
              disabled={false}
              handleChange={onFilterChange}
              maxDate={new Date()}
              open={createdDatePickerOpen}
              placeholder={placeholder}
              setOpen={setCreatedDatePickerOpen}
              value={createdAtDate}
            />
          </div>
          <ResetIconButton
            className="disabled:text-soClean-140 ml-6 shrink-0 basis-28"
            disabled={false}
            label="Reset Filters"
            onClick={handleFilterChange}
          />
        </div>
      )}
    </div>
  );
};
